import { Offcanvas } from "react-bootstrap";
import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

// Utilities
import FloatingLabelInput from "react-floating-label-input";

import { updateInfo } from "../../../Request/UserRequests";
import toast from "react-hot-toast";
import { saveUser } from "../../../Redux/Actions/userActions";

const EditDetail = ({showEditDetails, setShowEditDetails}) => {
  const user = useSelector((s) => s.user.info);
  const [states, setStates] = useState({
    name: user?.name,
    email: user?.email,
    phn: user?.phn,
  });
  const dispatch = useDispatch();
  const [load, setLoad] = useState(false);
  const [changes, setChanges] = useState(null);
  const [err, setErr] = useState({
    name: { err: false, msg: "" },
    email: { err: false, msg: "" },
  });

  useEffect(() => {
    if (states && user) {
      let change = {};
      let err = {
        name: { err: false, msg: "" },
        email: { err: false, msg: "" },
      };

      // Name
      if (states.name !== user.name) {
        if (states.name === "")
          err = { ...err, name: { err: true, msg: "Please enter name" } };
        change.name = states.name;
      }

      
      setChanges(change);
      setErr(err);
    }
  }, [states, user]);


  useEffect(
    () =>
      setStates({
        name: user?.name,
        email: user?.email,
        phn: user?.phn,
      }),
    [user]
  );

  const backdrop = useMemo(
    () => ({
      name: "Eable backdrop",
      scroll: false,
      backdrop: true,
    }),
    []
  );

  return (
    <Offcanvas
      show={showEditDetails}
      placement="bottom"
      onHide={() => setShowEditDetails(false)}
      className="h-auto bg-tr editDetailCanvas"
      {...backdrop}
    >
      <Offcanvas.Body>
        <div className="d-flex" onClick={()=>setShowEditDetails(false)}>
          <div className="bi bi-x-circle fs-lg mx-auto text-light"></div>
        </div>
        <div className="offcanvas-header">
          <h3 className="offset-title">Edit Details</h3>
        </div>
        <div className="offcanvas-body bg-white d-flex p-16">
          <div className="method-input">
            <FloatingLabelInput
              id="CName"
              label="Name"
              name="name"
              className="floating-label d-block"
              value={states?.name || ""}
              onChange={(e) =>
                setStates((s) => ({ ...s, name: e.target.value }))
              }
            />
          </div>
          <div className="method-input">
            <FloatingLabelInput
              id="MNumber"
              label="Mobile Number" 
              name="mobile-number"
              className="floating-label d-block"
              value={states?.phn || ""}
              readOnly
              disabled
            />
          </div>
          <button
          disabled={err.name.err}
            type="button"
            className="btn w-100 btn-orange text-orange"
            onClick={() => {
            
              setLoad(true);
              updateInfo(changes)
                .then((res) => {
                  toast.success("Saved");
                  dispatch(saveUser({ ...user, ...changes }));
                })
                .catch((err) => console.log(err))
                .finally(() => {setLoad(false);
                  setShowEditDetails(false)
                });
            }}
            >
            Save
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EditDetail;
